import { render, staticRenderFns } from "./PresetPages.vue?vue&type=template&id=f9576510&"
import script from "./PresetPages.vue?vue&type=script&lang=ts&"
export * from "./PresetPages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports